const DEFAULT_COLORS_CONFIG = ['#009fd4', '#00dbff', '#365f7d', '04a4ae', '#3e2c34'];

export default class ColorsConfigBuilder {
  #config = [...DEFAULT_COLORS_CONFIG];

  setColors(colors) {
    this.#config = colors;
  }

  build() {
    return this.#config;
  }
}
